// import React, { useEffect, useState } from "react";
// import CustomDialog from "../../../../components/Dialog/CustomDialog";
// import { Box } from "@mui/material";
// import { getRequest, postRequest } from "../../../../Apis";
// import { useNavigate } from "react-router-dom";
// import { campaignEndpoints } from "../../../../utils/constants/httpConstants";
// import EventEmitter from "../../../../utils/emitter/EventEmitter";
// import {
//   EACH_CAMPAIGN_STATS_TYPE,
//   EMITTER_ERROR,
//   EMITTER_SUCCESS,
//   ICON_BY_STEP_TYPE,
//   STATS_HEADERS,
//   STEP_TYPE_CHIP_BG,
// } from "../../../../utils/constants";
// import { STRINGS } from "../strings";
// import classes from "../markComponents.module.css";

// import IconComponent from "../../../../components/Icon/IconComponent";
// import {
//   ICON_LABELS,
//   fontSize,
//   fontWeight,
// } from "../../../../utils/constants/UI";
// import { BRAND, GREY } from "../../../../utils/constants/colors";
// import TypographyInline from "../../../../components/Typography/TypographyInline";
// import {
//   decompressString,
//   processStatsKeyValuePairs,
//   timeStampToDateTime,
// } from "../../../../utils/helpers";
// import SkeletonLoader from "../../../../components/Loaders/SkeletonLoader";
// import CustomTable from "../../../../components/Table/CustomTable";
// import CampaignStepSkeleton from "../common/CampaignStepSkeleton";
// import parse from "html-react-parser";
// import { Button } from "../../../../components/Buttons";
// import { useDispatch, useSelector } from "react-redux";
// import { paginationDataAction } from "../../../../redux/actions/customTableActions";
// let quotedPrintable = require("quoted-printable");

// const process_email_body = (body) => {
//   const start = body.indexOf("<div");
//   const end = body.lastIndexOf("/div>");
//   const response = body.slice(start, end + 5);
//   return response;
// };

// function decodeBase64(base64String) {
//   const base64Chars = STRINGS.ALPHANUMERIC;

//   const base64Lookup = new Uint8Array(256);
//   for (let i = 0; i < base64Chars.length; i++) {
//     base64Lookup[base64Chars.charCodeAt(i)] = i;
//   }

//   const padding = base64String.endsWith("==")
//     ? 2
//     : base64String.endsWith("=")
//     ? 1
//     : 0;
//   const byteLength = (base64String.length * 6) / 8 - padding;
//   const bytes = new Uint8Array(byteLength);

//   let byteIndex = 0;
//   let charIndex = 0;
//   while (charIndex < base64String.length) {
//     const enc1 = base64Lookup[base64String.charCodeAt(charIndex++)];
//     const enc2 = base64Lookup[base64String.charCodeAt(charIndex++)];
//     const enc3 = base64Lookup[base64String.charCodeAt(charIndex++)];
//     const enc4 = base64Lookup[base64String.charCodeAt(charIndex++)];

//     const byte1 = (enc1 << 2) | (enc2 >> 4);
//     const byte2 = ((enc2 & 15) << 4) | (enc3 >> 2);
//     const byte3 = ((enc3 & 3) << 6) | enc4;

//     bytes[byteIndex++] = byte1;
//     if (byteIndex < byteLength) {
//       bytes[byteIndex++] = byte2;
//     }
//     if (byteIndex < byteLength) {
//       bytes[byteIndex++] = byte3;
//     }
//   }

//   const decoder = new TextDecoder("utf-8");
//   const decodedString = decoder.decode(bytes);

//   return decodedString;
// }
// const StatsDialog = ({ open, setOpen, statsPayload }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [loadingSteps, setLoadingSteps] = useState(true);
//   const [loadingStats, setLoadingStats] = useState(true);
//   const [stats, setStats] = useState({});
//   const [steps, setSteps] = useState([]);
//   const [detailsLoading, setDetailsLoading] = useState(true);
//   const [records, setRecords] = useState([]);
//   const [isLeadShow, setIsLeadShow] = useState("0");
//   const [isUnsubscribeShow, setIsUnsubscribeShow] = useState("0");
//   const [selectedStep, setSelectedStep] = useState("");
//   const [tableHeads, setTableHeads] = useState([...STATS_HEADERS]);
//   const [currentType, setCurrentType] = useState(statsPayload?.head?.id || "");
//   const [currentReplyPayload, setCurrentReplyPayload] = useState({});
//   const [showReply, setShowReply] = useState(false);
//   const [replyContent, setReplyContent] = useState("");
//   const [unsubscribing, setUnsubscribing] = useState(false);
//   const [leadMarking, setLeadMarking] = useState(false);

//   const paginationDataSelector = useSelector(
//     (state) => state.getPaginationQuery
//   );

//   const handleStepSelection = (item) => {
//     setSelectedStep(item?._id);
//     dispatch(
//       paginationDataAction({
//         ...paginationDataSelector?.data,
//         campStats: {
//           ...paginationDataSelector?.data?.campStats,
//           query: {
//             page: 1,
//             limit: 25,
//           },
//         },
//       })
//     );
//     fetchStatsByStepId(item?._id);
//   };

//   const fetchStatsByStepId = async (step_id) => {
//     try {
//       setLoadingStats(true);
//       const stats_response = await postRequest(
//         navigate,
//         campaignEndpoints.stepWise,
//         { step_ids: [step_id] }
//       );
//       setStats(
//         processStatsKeyValuePairs(stats_response.data?.records?.[step_id] || {})
//       );
//       fetchRecordsByType(currentType, step_id);
//     } catch (error) {
//       EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
//     } finally {
//       setLoadingStats(false);
//     }
//   };

//   const fetchRecordsByType = async (type, step_id) => {
//     try {
//       setDetailsLoading(true);
//       const payload = {
//         campaign_id: statsPayload?.row?._id,
//         step_id: step_id,
//         type: type,
//         limit: paginationDataSelector?.data?.["campStats"]?.query?.limit || 25,
//         page: paginationDataSelector?.data?.["campStats"]?.query?.page || 1,
//       };
//       const records_payload = await postRequest(
//         navigate,
//         campaignEndpoints.campInStats,
//         payload
//       );
//       records_payload.data.records.data =
//         records_payload.data?.records?.data?.map((item) => {
//           return {
//             ...item,
//             [`${type}_${STRINGS.SMALL_DATE}`]: timeStampToDateTime(
//               parseInt(item[`${type}_${STRINGS.SMALL_DATE}`])
//             ),
//           };
//         });
//       setRecords(records_payload.data?.records);
//       const temp_table_heads = [...tableHeads];
//       temp_table_heads.pop();
//       if (temp_table_heads?.length >= 3) {
//         temp_table_heads.pop();
//       }
//       // if (type === STRINGS.SMALL_REPLY || type === STRINGS.SENT_SMALL || type === STRINGS.OPEN_SMALL) {
//       setTableHeads([
//         {
//           id: "name",
//           ui_id: "user_detail",
//           label: "Name",
//           width: "14.2vw",
//         },
//         {
//           id: "email",
//           ui_id: "stats_data",
//           label: "Email",
//           width: "14.2vw",
//         },
//         {
//           id: `${type}_${STRINGS.SMALL_DATE}`,
//           ui_id: "stats_data",
//           label: "Date",
//           width: "14.2vw",
//         },
//         {
//           id: STRINGS.SMALL_ACTION,
//           ui_id: STRINGS.SMALL_ACTION,
//           label: STRINGS.ACTION,
//           width: "10.063vw",
//         },
//       ]);
//     } catch (error) {
//       EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
//     } finally {
//       setDetailsLoading(false);
//     }
//   };

//   const handleTypeChange = (item) => {
//     try {
//       setCurrentType(item.key);
//       dispatch(
//         paginationDataAction({
//           ...paginationDataSelector?.data,
//           campStats: {
//             ...paginationDataSelector?.data?.campStats,
//             query: {
//               page: 1,
//               limit: 25,
//             },
//           },
//         })
//       );
//       fetchRecordsByType(item.key, selectedStep);
//     } catch (error) {}
//   };

//   const handleGetReply = async (campaign_id, step_id, email) => {
//     try {
//       const URL = `${campaignEndpoints.replyStats}?${STRINGS.STEP_ID}=${step_id}&${STRINGS.CAMPAIGN_ID}=${campaign_id}&${STRINGS.SMALL_EMAIL}=${email}`;
//       const reply_payload = await getRequest(navigate, URL);
//       console.log("REPST", reply_payload);
//       setIsLeadShow(reply_payload?.data?.hits?.hits[0]?._source?.lead);
//       setIsUnsubscribeShow(
//         reply_payload?.data?.hits?.hits[0]?._source?.unsubscribe
//       );
//       // attachments processing.
//       let images_html;
//       const attachments_payload =
//         reply_payload?.data?.hits?.hits?.[0]?._source?.attachments_data;

//       if (attachments_payload?.length) {
//         images_html = `<div>`;
//         for (let i in attachments_payload) {
//           const each_attachment = attachments_payload[i];
//           // adding img only for now.
//           const each_image = `<img style="width:80px; height: 80px;" src="${each_attachment?.src}" />`;
//           images_html += each_image;
//         }

//         images_html += "</div>";
//       }

//       let payload_data = { ...reply_payload?.data?.hits?.hits?.[0]?._source };
//       let reply = "";
//       if (currentType === "reply") {
//         if (payload_data?.is_compressed) {
//           reply = `${decodeURIComponent(
//             decompressString(payload_data?.reply_html_payload || "")
//           )} ${images_html || ""}`;
//         } else {
//           reply = `<div>${payload_data?.reply_html_payload || ""} ${
//             images_html || ""
//           }</div>`;
//         }
//       } else {
//         reply = `<div>${payload_data?.email_body || ""} ${
//           images_html || ""
//         }</div>`;
//       }

//       if (reply) {
//         setReplyContent(reply);
//       } else {
//         // old reply formats.
//         const base64Decoded = decodeBase64(payload_data?.reply_payload || "");
//         const onlyHtml = process_email_body(base64Decoded);
//         const html = quotedPrintable.decode(onlyHtml);
//         setReplyContent(html);
//       }
//       //
//     } catch (error) {
//       console.log("Error ", error);
//       EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
//     } finally {
//     }
//   };

//   const handleViewReply = (row, head) => {
//     try {
//       setCurrentReplyPayload(row);
//       setShowReply(true);
//       handleGetReply(row?.campaign_id, row?.step_id, row?.email);
//     } catch (error) {}
//   };

//   const handleMarkAsUnsubscribe = async () => {
//     try {
//       setUnsubscribing(true);
//       const payload = {
//         campaign_id: currentReplyPayload?.campaign_id,
//         step_id: currentReplyPayload?.step_id,
//         email: currentReplyPayload?.email,
//       };
//       const response = await postRequest(
//         navigate,
//         campaignEndpoints.markAsUnsubscribe,
//         payload
//       );
//       setIsUnsubscribeShow("1");
//       EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
//     } catch (error) {
//       EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
//     } finally {
//       setUnsubscribing(false);
//     }
//   };

//   const handleMarkAsLead = async () => {
//     try {
//       setLeadMarking(true);
//       const payload = {
//         campaign_id: currentReplyPayload?.campaign_id,
//         step_id: currentReplyPayload?.step_id,
//         email: currentReplyPayload?.email,
//       };
//       const response = await postRequest(
//         navigate,
//         campaignEndpoints.markAsLead,
//         payload
//       );
//       EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
//       setIsLeadShow("1");
//     } catch (error) {
//       EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
//     } finally {
//       setLeadMarking(false);
//     }
//   };

//   useEffect(() => {
//     // fetch steps details;
//     (async () => {
//       try {
//         if (!steps?.length) {
//           const response = await getRequest(
//             navigate,
//             `${campaignEndpoints.allStats}/${statsPayload?.row?.cam_sequence_id}`
//           );
//           setSteps(response?.data?.data || []);
//           setSelectedStep(response?.data?.data?.[0]?._id);
//           fetchStatsByStepId(response?.data?.data?.[0]?._id);
//         } else {
//           setSelectedStep(selectedStep);
//           fetchStatsByStepId(selectedStep);
//         }
//       } catch (error) {
//         EventEmitter.emit(EMITTER_ERROR, error.data.message);
//       } finally {
//         setLoadingSteps(false);
//       }
//     })();
//   }, [
//     paginationDataSelector?.data?.["campStats"]?.query?.page,
//     paginationDataSelector?.data?.["campStats"]?.query?.limit,
//   ]);

//   // Header
//   const dialogHeader = {
//     heading: {
//       id: statsPayload?.row?._id,
//       label: statsPayload?.row?.name,
//     },
//   };

//   const statsTableData = {
//     heads: tableHeads,
//     body: records?.data,
//     total_records: records?.count,
//     isLoading: detailsLoading || detailsLoading,
//     is_selection_not_allowed: true,
//     operations: [
//       {
//         id: currentType === "reply" ? STRINGS.VIEW_REPLY : STRINGS.VIEW_EMAIL,
//         label:
//           currentType === "reply" ? STRINGS.VIEW_REPLY : STRINGS.VIEW_EMAIL,
//         iconLabel: ICON_LABELS.VISIBILITY_ON,
//         function: handleViewReply,
//       },
//     ],
//     id: "campStats",
//   };

//   // Dialog Body
//   const body = (
//     <Box className={classes.statsContainer}>
//       {/* Steps Container */}
//       <Box className={classes.containSteps}>
//         {loadingSteps ? (
//           <CampaignStepSkeleton />
//         ) : (
//           steps.map((item, index) => {
//             return (
//               item?.step_type === 1 && (
//                 <Box>
//                   <Box
//                     key={index}
//                     className={
//                       selectedStep === item?._id
//                         ? classes.eachSelectedStatStep
//                         : index > 0
//                         ? classes.eachStatStep1
//                         : classes.eachStatStep
//                     }
//                     onClick={(e) => handleStepSelection(item)}
//                   >
//                     <IconComponent
//                       color={
//                         selectedStep === item?._id
//                           ? STEP_TYPE_CHIP_BG[item.step_type]
//                           : GREY.SECONDARY
//                       }
//                       fontSize={fontSize.XL}
//                       iconLabel={ICON_BY_STEP_TYPE[item?.step_type]}
//                     />
//                     <TypographyInline
//                       isEllipses={true}
//                       label={`${STRINGS.STEP} ${index + 1}`}
//                       size={"md"}
//                       fontWeight={
//                         selectedStep === item?._id
//                           ? fontWeight.SEMIBOLD
//                           : fontWeight.MEDIUM
//                       }
//                       color={
//                         selectedStep === item?._id
//                           ? STEP_TYPE_CHIP_BG[item.step_type]
//                           : GREY.SECONDARY
//                       }
//                     />
//                   </Box>
//                   {steps?.length - 1 != index && (
//                     <Box className={classes.stepSaperator}></Box>
//                   )}
//                 </Box>
//               )
//             );
//           })
//         )}
//       </Box>
//       {/* Stats and Table Container */}
//       <Box className={classes.mainContainer}>
//         {/* Stats Container */}
//         <Box className={classes.statsCountContainer} id="modal_body">
//           {EACH_CAMPAIGN_STATS_TYPE.map((item) => {
//             return (
//               <Box
//                 key={item.key}
//                 className={classes.eachCountContainer}
//                 onClick={() => handleTypeChange(item)}
//               >
//                 {loadingStats ? (
//                   <Box>
//                     <SkeletonLoader
//                       skeletonWidth={16}
//                       skeletonHeight={20}
//                       variant="rounded"
//                     />
//                   </Box>
//                 ) : (
//                   <TypographyInline
//                     label={stats?.[item.key]}
//                     size={"sm"}
//                     fontWeight={
//                       item?.key === currentType
//                         ? fontWeight.MEDIUM
//                         : fontWeight.REGULAR
//                     }
//                     color={
//                       item?.key === currentType ? BRAND.PRIMARY : GREY.SECONDARY
//                     }
//                   />
//                 )}

//                 <TypographyInline
//                   className={item?.key === currentType && classes.selectedType}
//                   label={item.label}
//                   size={"sm"}
//                   fontWeight={
//                     item?.key === currentType
//                       ? fontWeight.MEDIUM
//                       : fontWeight.REGULAR
//                   }
//                   color={
//                     item?.key === currentType ? BRAND.PRIMARY : GREY.SECONDARY
//                   }
//                 />
//               </Box>
//             );
//           })}
//         </Box>
//         {/* Table Container */}
//         <Box className={classes.tableContainerSt}>
//           <CustomTable tableData={statsTableData} />
//         </Box>
//       </Box>
//     </Box>
//   );

//   // Reply Dialog content

//   // header
//   const replyHeader = {
//     heading: {
//       id: currentReplyPayload?.step_id,
//       label: `${currentReplyPayload?.first_name || ""} ${
//         currentReplyPayload?.last_name || ""
//       }`,
//     },
//   };

//   const replyBody = <Box>{parse(replyContent)}</Box>;

//   const replyFooter = (
//     <Box className={classes.footerContainerUn}>
//       {isUnsubscribeShow != "1" && (
//         <Box>
//           <Button
//             label={STRINGS.UNSUBSCRIBE}
//             size={"sm36"}
//             variant={"ghost"}
//             onClick={handleMarkAsUnsubscribe}
//             isLoading={unsubscribing}
//           />
//         </Box>
//       )}
//       {isLeadShow != "1" && (
//         <Box>
//           <Button
//             label={STRINGS.MARK_AS_LEAD}
//             size={"sm36"}
//             variant={"primary"}
//             onClick={handleMarkAsLead}
//             isLoading={leadMarking}
//           />
//         </Box>
//       )}
//     </Box>
//   );

//   return (
//     <>
//       <CustomDialog
//         open={open}
//         remove_padding={true}
//         header={dialogHeader}
//         onClose={() => setOpen(!open)}
//         width={"60vw"}
//         marginRight={showReply ? "25vw !important" : "0"}
//       >
//         {body}
//       </CustomDialog>
//       <CustomDialog
//         open={showReply}
//         header={replyHeader}
//         onClose={() => setShowReply(!showReply)}
//         width={"35vw"}
//         footer={currentType === "reply" ? replyFooter : null}
//       >
//         {replyBody}
//       </CustomDialog>
//     </>
//   );
// };
// export default StatsDialog;

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import CustomDialog from "../../../../components/Dialog/CustomDialog";
import { Box } from "@mui/material";
import { getRequest, postRequest } from "../../../../Apis";
import { useNavigate } from "react-router-dom";
import { campaignEndpoints } from "../../../../utils/constants/httpConstants";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import {
  EACH_CAMPAIGN_STATS_TYPE,
  EMITTER_ERROR,
  EMITTER_SUCCESS,
  ICON_BY_STEP_TYPE,
  STATS_HEADERS,
  STEP_TYPE_CHIP_BG,
} from "../../../../utils/constants";
import { STRINGS } from "../strings";
import classes from "../markComponents.module.css";
import IconComponent from "../../../../components/Icon/IconComponent";
import {
  ICON_LABELS,
  fontSize,
  fontWeight,
} from "../../../../utils/constants/UI";
import { BRAND, GREY } from "../../../../utils/constants/colors";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import {
  decompressString,
  processStatsKeyValuePairs,
  timeStampToDateTime,
} from "../../../../utils/helpers";
import SkeletonLoader from "../../../../components/Loaders/SkeletonLoader";
import CustomTable from "../../../../components/Table/CustomTable";
import CustomModal from "../../../../components/Modals/CustomModal";
import CampaignStepSkeleton from "../common/CampaignStepSkeleton";
import parse from "html-react-parser";
import { Button } from "../../../../components/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { paginationDataAction } from "../../../../redux/actions/customTableActions";
import FilterTab from "../../../../components/FilterTab/FilterTab";
import { csvDownload1 } from "../../../../utils/helpers";
let quotedPrintable = require("quoted-printable");

// Updated inline styles object with compact card layout
const styles = {
  statsContainer: {
    display: "flex",
    width: "100%",
    height: "-webkit-fill-available",
  },
  containSteps: {
    width: "13%",
    background: "#f8f8f8",
  },
  stepBox: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    cursor: "pointer",
  },
  selectedStep: {
    background: "#ffffff",
    boxShadow: "inset 2px 0px 0px 0px #2080f6",
    padding: "1rem",
  },
  firstStep: {
    padding: "1rem 1rem 1rem 1rem",
  },
  otherStep: {
    padding: "0 1rem 1rem 1rem",
  },
  separator: {
    height: "1rem",
    borderLeft: "1px solid #dbdbdb",
    margin: "1rem",
    marginLeft: "53px",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    width: "87%",
    height: "100%",
  },
  statsCountContainer: {
    display: "flex",
    gap: "0.5rem",
    padding: "0.75rem 1rem",
    flexWrap: "nowrap",
    justifyContent: "space-between", // Distribute evenly
    alignItems: "stretch",
  },
  eachCountCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.625rem 0.875rem", // Smaller padding
    background: "#ffffff",
    borderRadius: "6px",
    border: "1px solid #e6e6e6",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.06)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flex: "1 1 0", // Equal flex distribution
    minWidth: "0", // Allow shrinking
    maxWidth: "140px", // Cap maximum width
  },
  selectedCard: {
    background: "#ffffff",
    border: `2px solid ${BRAND.PRIMARY}`,
    boxShadow:
      "0px 4px 10px rgba(32, 128, 246, 0.12), 0px 2px 4px rgba(32, 128, 246, 0.08)",
    transform: "translateY(-2px)",
  },
  cardHover: {
    boxShadow:
      "0px 4px 10px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.04)",
    transform: "translateY(-1px)",
  },
  tableContainer: {
    border: "1px solid #e6e6e6",
    margin: "1rem",
    height: "calc(100% - 110px)",
    marginTop: "0",
    borderRadius: "8px",
    overflow: "hidden",
  },
  skeletonBox: {
    display: "flex",
    flexDirection: "column",
    gap: "0.375rem",
    alignItems: "center",
  },
  footerContainer: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  statValue: {
    fontSize: "1.25rem", // Smaller font
    fontWeight: "600",
    marginBottom: "0.125rem",
    lineHeight: "1.2",
  },
  statLabel: {
    fontSize: "0.75rem", // Smaller font
    textAlign: "center",
    lineHeight: "1.3",
  },
};

const process_email_body = (body) => {
  const start = body.indexOf("<div");
  const end = body.lastIndexOf("/div>");
  const response = body.slice(start, end + 5);
  return response;
};

function decodeBase64(base64String) {
  const base64Chars = STRINGS.ALPHANUMERIC;

  const base64Lookup = new Uint8Array(256);
  for (let i = 0; i < base64Chars.length; i++) {
    base64Lookup[base64Chars.charCodeAt(i)] = i;
  }

  const padding = base64String.endsWith("==")
    ? 2
    : base64String.endsWith("=")
      ? 1
      : 0;
  const byteLength = (base64String.length * 6) / 8 - padding;
  const bytes = new Uint8Array(byteLength);

  let byteIndex = 0;
  let charIndex = 0;
  while (charIndex < base64String.length) {
    const enc1 = base64Lookup[base64String.charCodeAt(charIndex++)];
    const enc2 = base64Lookup[base64String.charCodeAt(charIndex++)];
    const enc3 = base64Lookup[base64String.charCodeAt(charIndex++)];
    const enc4 = base64Lookup[base64String.charCodeAt(charIndex++)];

    const byte1 = (enc1 << 2) | (enc2 >> 4);
    const byte2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    const byte3 = ((enc3 & 3) << 6) | enc4;

    bytes[byteIndex++] = byte1;
    if (byteIndex < byteLength) {
      bytes[byteIndex++] = byte2;
    }
    if (byteIndex < byteLength) {
      bytes[byteIndex++] = byte3;
    }
  }

  const decoder = new TextDecoder("utf-8");
  const decodedString = decoder.decode(bytes);

  return decodedString;
}

const StatsDialog = ({ open, setOpen, statsPayload, showProfileHandle }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loadingSteps, setLoadingSteps] = useState(true);
  const [loadingStats, setLoadingStats] = useState(true);
  const [stats, setStats] = useState({});
  const [steps, setSteps] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(true);
  const [records, setRecords] = useState([]);
  const [isLeadShow, setIsLeadShow] = useState("0");
  const [isUnsubscribeShow, setIsUnsubscribeShow] = useState("0");
  const [selectedStep, setSelectedStep] = useState("");
  const [tableHeads, setTableHeads] = useState([...STATS_HEADERS]);
  const [currentType, setCurrentType] = useState(statsPayload?.head?.id || "");
  const [currentReplyPayload, setCurrentReplyPayload] = useState({});
  const [showReply, setShowReply] = useState(false);
  const [replyContent, setReplyContent] = useState("");
  const [unsubscribing, setUnsubscribing] = useState(false);
  const [leadMarking, setLeadMarking] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showAddToCrmModal, setShowAddToCrmModal] = useState(false);
  const [crmContactEmails, setCrmContactEmails] = useState([]);
  const [crmSelectionBulk, setCrmSelectionBulk] = useState(false);
  const [addingToCrm, setAddingToCrm] = useState(false);
  // checkedRow persists across pagination but records.data only holds the
  // current page, so bulk Add to CRM resolves emails from this accumulated map.
  const crmEmailByIdRef = useRef({});

  const paginationDataSelector = useSelector(
    (state) => state.getPaginationQuery,
  );

  useEffect(() => {
    if (paginationDataSelector?.data?.campStats?.checkedRow?.length) {
      setSelectedIds(paginationDataSelector?.data?.campStats?.checkedRow);
    } else {
      setSelectedIds([]);
    }
  }, [paginationDataSelector?.data?.campStats?.checkedRow]);

  const handleStepSelection = (item) => {
    setSelectedStep(item?._id);
    dispatch(
      paginationDataAction({
        ...paginationDataSelector?.data,
        campStats: {
          ...paginationDataSelector?.data?.campStats,
          query: {
            page: 1,
            limit: 25,
          },
          checkedRow: [],
        },
      }),
    );
    fetchStatsByStepId(item?._id);
  };

  const fetchStatsByStepId = async (step_id) => {
    try {
      setLoadingStats(true);
      const payload = { step_ids: [step_id] };
      if (!step_id) {
        payload.campaign_id = statsPayload?.row?._id;
      }
      const stats_response = await postRequest(
        navigate,
        campaignEndpoints.stepWise,
        payload,
      );
      setStats(
        processStatsKeyValuePairs(
          stats_response.data?.records?.[step_id] || {},
        ),
      );
      fetchRecordsByType(currentType, step_id);
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    } finally {
      setLoadingStats(false);
    }
  };

  const fetchRecordsByType = async (type, step_id) => {
    try {
      setDetailsLoading(true);
      const payload = {
        campaign_id: statsPayload?.row?._id,
        step_id: step_id,
        type: type,
        limit: paginationDataSelector?.data?.["campStats"]?.query?.limit || 25,
        page: paginationDataSelector?.data?.["campStats"]?.query?.page || 1,
      };
      const records_payload = await postRequest(
        navigate,
        campaignEndpoints.campInStats,
        payload,
      );
      records_payload.data.records.data =
        records_payload.data?.records?.data?.map((item) => {
          return {
            ...item,
            // contact-wise-stats rows carry no _id (the API returns only
            // _source fields), but checkbox selection, export, and the CRM
            // email map all key on _id — derive a stable one from the email.
            _id: item?._id || item?.email,
            name:
              `${item.first_name || ""} ${item.last_name || ""}`.trim() ||
              item.email,
            [`${type}_${STRINGS.SMALL_DATE}`]: timeStampToDateTime(
              parseInt(item[`${type}_${STRINGS.SMALL_DATE}`]),
            ),
          };
        });
      setRecords(records_payload.data?.records);
      (records_payload.data?.records?.data || []).forEach((item) => {
        if (item?._id) {
          crmEmailByIdRef.current[item._id] = item.email;
        }
      });
      const temp_table_heads = [...tableHeads];
      temp_table_heads.pop();
      if (temp_table_heads?.length >= 3) {
        temp_table_heads.pop();
      }
      setTableHeads([
        {
          id: "name",
          ui_id: "marketing_list",
          label: "Name",
          width: "14.2vw",
          isClickAllowed: true,
        },
        {
          id: "email",
          ui_id: "stats_data",
          label: "Email",
          width: "14.2vw",
        },
        {
          id: `${type}_${STRINGS.SMALL_DATE}`,
          ui_id: "stats_data",
          label: "Date",
          width: "14.2vw",
        },
        {
          id: STRINGS.SMALL_ACTION,
          ui_id: STRINGS.SMALL_ACTION,
          label: STRINGS.ACTION,
          width: "7.6vw",
        },
      ]);
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleTypeChange = (item) => {
    try {
      setCurrentType(item.key);
      dispatch(
        paginationDataAction({
          ...paginationDataSelector?.data,
          campStats: {
            ...paginationDataSelector?.data?.campStats,
            query: {
              page: 1,
              limit: 25,
            },
            checkedRow: [],
          },
        }),
      );
      fetchRecordsByType(item.key, selectedStep);
    } catch (error) {}
  };

  const handleGetReply = useCallback(
    async (campaign_id, step_id, email) => {
    try {
      const URL = `${campaignEndpoints.replyStats}?${STRINGS.STEP_ID}=${step_id}&${STRINGS.CAMPAIGN_ID}=${campaign_id}&${STRINGS.SMALL_EMAIL}=${email}`;
      const reply_payload = await getRequest(navigate, URL);
      setIsLeadShow(reply_payload?.data?.hits?.hits[0]?._source?.lead);
      setIsUnsubscribeShow(
        reply_payload?.data?.hits?.hits[0]?._source?.unsubscribe,
      );

      let images_html;
      const attachments_payload =
        reply_payload?.data?.hits?.hits?.[0]?._source?.attachments_data;

      if (attachments_payload?.length) {
        images_html = `<div>`;
        for (let i in attachments_payload) {
          const each_attachment = attachments_payload[i];
          const each_image = `<img style="width:80px; height: 80px;" src="${each_attachment?.src}" />`;
          images_html += each_image;
        }
        images_html += "</div>";
      }

      let payload_data = { ...reply_payload?.data?.hits?.hits?.[0]?._source };
      let reply = "";
      if (currentType === "reply") {
        if (payload_data?.is_compressed) {
          reply = `${decodeURIComponent(
            decompressString(payload_data?.reply_html_payload || ""),
          )} ${images_html || ""}`;
        } else {
          reply = `<div>${payload_data?.reply_html_payload || ""} ${
            images_html || ""
          }</div>`;
        }
      } else {
        reply = `<div>${payload_data?.email_body || ""} ${
          images_html || ""
        }</div>`;
      }

      if (reply) {
        setReplyContent(reply);
      } else {
        const base64Decoded = decodeBase64(payload_data?.reply_payload || "");
        const onlyHtml = process_email_body(base64Decoded);
        const html = quotedPrintable.decode(onlyHtml);
        setReplyContent(html);
      }
    } catch (error) {
      console.log("Error ", error);
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    } finally {
    }
    },
    [navigate, currentType],
  );

  const handleViewReply = useCallback(
    (row, head) => {
    try {
      setCurrentReplyPayload(row);
      setShowReply(true);
      handleGetReply(row?.campaign_id, row?.step_id, row?.email);
    } catch (error) {}
    },
    [handleGetReply],
  );

  const handleAddToCrm = useCallback((row) => {
    setCrmContactEmails([row?.email]);
    setCrmSelectionBulk(false);
    setShowAddToCrmModal(true);
  }, []);

  const handleBulkAddToCrm = useCallback(() => {
    const emails = [
      ...new Set(
        selectedIds.map((id) => crmEmailByIdRef.current[id]).filter(Boolean),
      ),
    ];
    if (!emails.length) {
      EventEmitter.emit(EMITTER_ERROR, "Please select contacts to add to CRM");
      return;
    }
    setCrmContactEmails(emails);
    setCrmSelectionBulk(true);
    setShowAddToCrmModal(true);
  }, [selectedIds]);

  const closeAddToCrmModal = () => {
    if (addingToCrm) return;
    setShowAddToCrmModal(false);
    setCrmContactEmails([]);
  };

  const addContactToCrm = async () => {
    try {
      setAddingToCrm(true);
      const res = await postRequest(
        navigate,
        campaignEndpoints.addContactToCRM,
        {
          emails: crmContactEmails,
          campaign_id: statsPayload?.row?._id,
        },
      );
      // The backend refuses an address that unsubscribed or whose mailbox bounced, and returns the
      // reason per email. Say so instead of reporting a blanket success - a rep who is told
      // "Contact added to CRM" and then cannot find the contact reports it as a bug.
      const refused = (res?.data?.data?.errors || []).filter((e) =>
        ["unsubscribed", "bounced"].includes(e?.reason),
      );
      const addedCount = crmContactEmails.length - refused.length;
      if (refused.length) {
        const naming = refused
          .slice(0, 3)
          .map((e) => `${e.email} (${e.reason})`)
          .join(", ");
        const more = refused.length > 3 ? ` +${refused.length - 3} more` : "";
        EventEmitter.emit(
          addedCount > 0 ? EMITTER_SUCCESS : EMITTER_ERROR,
          addedCount > 0
            ? `${addedCount} added. Not added: ${naming}${more}`
            : `Not added - ${naming}${more}`,
        );
      } else {
        EventEmitter.emit(
          EMITTER_SUCCESS,
          res?.data?.message ||
            (crmContactEmails.length > 1
              ? "Contacts added to CRM"
              : "Contact added to CRM"),
        );
      }
      if (crmSelectionBulk) {
        // Fresh top-level checkedRow identity forces CustomTable's checkbox
        // sync effect (which depends on it, not the nested key) to re-run.
        dispatch(
          paginationDataAction({
            ...paginationDataSelector?.data,
            checkedRow: [],
            campStats: {
              ...paginationDataSelector?.data?.campStats,
              checkedRow: [],
            },
          }),
        );
      }
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    } finally {
      setAddingToCrm(false);
      setShowAddToCrmModal(false);
      setCrmContactEmails([]);
    }
  };

  const handleMarkAsUnsubscribe = async () => {
    try {
      setUnsubscribing(true);
      const payload = {
        campaign_id: currentReplyPayload?.campaign_id,
        step_id: currentReplyPayload?.step_id,
        email: currentReplyPayload?.email,
      };
      const response = await postRequest(
        navigate,
        campaignEndpoints.markAsUnsubscribe,
        payload,
      );
      setIsUnsubscribeShow("1");
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    } finally {
      setUnsubscribing(false);
    }
  };

  // Marking a reply as a lead and putting that person in CRM is one decision, so it is one call.
  // save-with-campaign creates the CRM contact, rebuilds its timeline from the campaign history,
  // and (with mark_as_lead) stamps the lead and sets the campaign's lead stat — the work that used
  // to need a second request to campaign/contacts/mark-as-lead. Without the CRM half, a qualified
  // lead stayed a marketing-list row whose timeline could never fill.
  const handleMarkAsLead = async () => {
    try {
      setLeadMarking(true);
      const payload = {
        emails: [currentReplyPayload?.email],
        campaign_id: currentReplyPayload?.campaign_id,
        step_id: currentReplyPayload?.step_id,
        mark_as_lead: true,
      };
      const response = await postRequest(
        navigate,
        campaignEndpoints.addContactToCRM,
        payload,
      );
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
      setIsLeadShow("1");
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    } finally {
      setLeadMarking(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        console.log("statsPayload", statsPayload);
        if (!steps?.length) {
          const campaignData = statsPayload?.row;
          const statsUrl =
            !campaignData?.cam_sequence_id ||
            campaignData?.cam_sequence_id === ""
              ? `${campaignEndpoints.allStats}/by-campaign/${campaignData?._id}`
              : `${campaignEndpoints.allStats}/${campaignData?.cam_sequence_id}`;

          console.log("Fetching steps from URL:", statsUrl);

          const response = await getRequest(navigate, statsUrl);
          setSteps(response?.data?.data || []);
          setSelectedStep(response?.data?.data?.[0]?._id);
          fetchStatsByStepId(response?.data?.data?.[0]?._id);
        } else {
          setSelectedStep(selectedStep);
          fetchStatsByStepId(selectedStep);
        }
      } catch (error) {
        EventEmitter.emit(EMITTER_ERROR, error.data.message);
      } finally {
        setLoadingSteps(false);
      }
    })();
  }, [
    paginationDataSelector?.data?.["campStats"]?.query?.page,
    paginationDataSelector?.data?.["campStats"]?.query?.limit,
  ]);

  const dialogHeader = {
    heading: {
      id: statsPayload?.row?._id,
      label: statsPayload?.row?.name,
    },
  };

  const handleExportStats = useCallback(async () => {
    try {
      setExporting(true);
      const email_records = records?.data
        ?.filter((item) => selectedIds.includes(item?._id))
        ?.map((item) => item.email);

      const payload = {
        campaign_id: statsPayload?.row?._id,
        email_records: email_records,
      };

      const response = await postRequest(
        navigate,
        campaignEndpoints.exportCampaignContacts,
        payload,
        {},
        { responseType: "blob" },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "campaign-contacts-export.csv";
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      EventEmitter.emit(EMITTER_SUCCESS, "Exported successfully");
      setExporting(false);
      dispatch(
        paginationDataAction({
          ...paginationDataSelector?.data,
          campStats: {
            ...paginationDataSelector?.data?.campStats,
            checkedRow: [],
          },
        }),
      );
    } catch (err) {
      setExporting(false);
      EventEmitter.emit(EMITTER_ERROR, err?.data?.message || "Export failed");
    }
  }, [records?.data, selectedIds, statsPayload?.row?._id, navigate, paginationDataSelector?.data, dispatch]);

  const handleMarketingListClick = useCallback(
    (row) => showProfileHandle(row.email),
    [showProfileHandle],
  );

  const statsTableData = useMemo(
    () => ({
    heads: tableHeads,
    body: records?.data,
    total_records: records?.count,
    isLoading: detailsLoading,
    is_selection_not_allowed: false,
    actions: {
      marketing_list: {
        function: handleMarketingListClick,
      },
    },
    operations: [
      {
        id: currentType === "reply" ? STRINGS.VIEW_REPLY : STRINGS.VIEW_EMAIL,
        label:
          currentType === "reply" ? STRINGS.VIEW_REPLY : STRINGS.VIEW_EMAIL,
        iconLabel: ICON_LABELS.VISIBILITY_ON,
        function: handleViewReply,
      },
      ...(currentType === "open"
        ? [
            {
              id: STRINGS.ADD_TO_CRM,
              label: STRINGS.ADD_TO_CRM,
              iconLabel: ICON_LABELS.PERSON_ADD,
              function: handleAddToCrm,
            },
          ]
        : []),
    ],
    id: "campStats",
    is_space_between: true,
    }),
    [
      tableHeads,
      records?.data,
      records?.count,
      detailsLoading,
      currentType,
      handleViewReply,
      handleMarketingListClick,
      handleAddToCrm,
    ],
  );

  // Memoized so CustomTable's React.memo can bail — a fresh array/element each
  // render would defeat the memo even with a stable tableData.
  const headerStrip = useMemo(
    () => [
      ...(currentType === "open"
        ? [
            <Button
              LeftIcon={ICON_LABELS.PERSON_ADD}
              label={STRINGS.ADD_TO_CRM}
              size={"sm36"}
              variant={"ghost"}
              onClick={handleBulkAddToCrm}
            />,
          ]
        : []),
      <Button
        LeftIcon={ICON_LABELS.DOWNLOAD}
        label={"Export"}
        size={"sm36"}
        variant={"ghost"}
        onClick={handleExportStats}
        isLoading={exporting}
      />,
    ],
    [handleExportStats, exporting, currentType, handleBulkAddToCrm],
  );

  const body = (
    <Box style={styles.statsContainer}>
      {/* Steps Container */}
      <Box style={styles.containSteps}>
        {loadingSteps ? (
          <CampaignStepSkeleton count={3} />
        ) : (
          steps
            .filter((item) => item?.step_type === 1)
            .map((item, filteredIndex) => {
              const isSelected = selectedStep === item?._id;
              const isFirstStep = filteredIndex === 0;
              const emailSteps = steps.filter((s) => s.step_type === 1);
              const isLastStep = filteredIndex === emailSteps.length - 1;

              return (
                <React.Fragment key={item?._id}>
                  <Box
                    style={{
                      ...styles.stepBox,
                      ...(isSelected
                        ? styles.selectedStep
                        : isFirstStep
                          ? styles.firstStep
                          : styles.otherStep),
                    }}
                    onClick={() => handleStepSelection(item)}
                  >
                    <IconComponent
                      color={
                        isSelected
                          ? STEP_TYPE_CHIP_BG[item.step_type]
                          : GREY.SECONDARY
                      }
                      fontSize={fontSize.XL}
                      iconLabel={ICON_BY_STEP_TYPE[item?.step_type]}
                    />
                    <TypographyInline
                      isEllipses={true}
                      label={`${STRINGS.STEP} ${filteredIndex + 1}`}
                      size={"md"}
                      fontWeight={
                        isSelected ? fontWeight.SEMIBOLD : fontWeight.MEDIUM
                      }
                      color={
                        isSelected
                          ? STEP_TYPE_CHIP_BG[item.step_type]
                          : GREY.SECONDARY
                      }
                    />
                  </Box>
                  {!isLastStep && <Box style={styles.separator} />}
                </React.Fragment>
              );
            })
        )}
      </Box>

      {/* Stats and Table Container */}
      <Box style={styles.mainContainer}>
        {/* Stats Cards Container */}
        <Box style={styles.statsCountContainer} id="modal_body">
          {EACH_CAMPAIGN_STATS_TYPE.map((item) => {
            const isSelected = item?.key === currentType;

            return (
              <Box
                key={item.key}
                sx={{
                  ...styles.eachCountCard,
                  ...(isSelected && styles.selectedCard),
                  cursor: loadingStats ? "default" : "pointer",
                  pointerEvents: loadingStats ? "none" : "auto",
                  ...(!isSelected && { "&:hover": styles.cardHover }),
                }}
                onClick={() => !loadingStats && handleTypeChange(item)}
              >
                {loadingStats ? (
                  <Box style={styles.skeletonBox}>
                    <SkeletonLoader
                      skeletonWidth={50}
                      skeletonHeight={28}
                      variant="text"
                    />
                    <SkeletonLoader
                      skeletonWidth={70}
                      skeletonHeight={18}
                      variant="text"
                    />
                  </Box>
                ) : (
                  <>
                    <Box style={styles.statValue}>
                      <TypographyInline
                        label={stats?.[item.key] || 0}
                        size={"lg"}
                        fontWeight={fontWeight.SEMIBOLD}
                        color={isSelected ? BRAND.PRIMARY : GREY.PRIMARY}
                      />
                    </Box>
                    <Box style={styles.statLabel}>
                      <TypographyInline
                        label={item.label}
                        size={"sm"}
                        fontWeight={fontWeight.MEDIUM}
                        color={isSelected ? BRAND.PRIMARY : GREY.SECONDARY}
                      />
                    </Box>
                  </>
                )}
              </Box>
            );
          })}
        </Box>

        {/* Table Container */}
        <Box style={styles.tableContainer}>
          <CustomTable tableData={statsTableData} headerStrip={headerStrip} />
        </Box>
      </Box>
    </Box>
  );

  const replyHeader = {
    heading: {
      id: currentReplyPayload?.step_id,
      label: `${currentReplyPayload?.first_name || ""} ${
        currentReplyPayload?.last_name || ""
      }`,
    },
  };

  const replyBody = <Box>{parse(replyContent)}</Box>;

  const replyFooter = (
    <Box style={styles.footerContainer}>
      {isUnsubscribeShow !== "1" && (
        <Button
          label={STRINGS.UNSUBSCRIBE}
          size={"sm36"}
          variant={"ghost"}
          onClick={handleMarkAsUnsubscribe}
          isLoading={unsubscribing}
        />
      )}
      {isLeadShow !== "1" && (
        <Button
          label={STRINGS.MARK_AS_LEAD}
          size={"sm36"}
          variant={"primary"}
          onClick={handleMarkAsLead}
          isLoading={leadMarking}
        />
      )}
    </Box>
  );

  return (
    <>
      <CustomDialog
        open={open}
        remove_padding={true}
        header={dialogHeader}
        onClose={() => {
          setOpen(!open);
          dispatch(
            paginationDataAction({
              ...paginationDataSelector?.data,
              campStats: {},
            }),
          );
        }}
        width={"60vw"}
        marginRight={showReply ? "25vw !important" : "0"}
      >
        {body}
      </CustomDialog>
      <CustomDialog
        open={showReply}
        header={replyHeader}
        onClose={() => setShowReply(!showReply)}
        width={"35vw"}
        footer={currentType === "reply" ? replyFooter : null}
      >
        {replyBody}
      </CustomDialog>
      {showAddToCrmModal && (
        <CustomModal
          open={true}
          close={closeAddToCrmModal}
          header={{
            heading: { id: STRINGS.ADD_TO_CRM, label: STRINGS.ADD_TO_CRM },
          }}
          footer={{
            right: (
              <Box style={{ display: "flex", gap: "12px" }}>
                <Button
                  label={STRINGS.CANCEL}
                  variant={"ghost"}
                  size={"sm36"}
                  disabled={addingToCrm}
                  onClick={closeAddToCrmModal}
                />
                <Button
                  label={STRINGS.ADD}
                  size={"sm36"}
                  variant={"primary"}
                  isLoading={addingToCrm}
                  onClick={addContactToCrm}
                />
              </Box>
            ),
          }}
        >
          <TypographyInline
            label={
              crmContactEmails.length > 1
                ? `Would you like to add these ${crmContactEmails.length} contacts to your CRM?`
                : STRINGS.ADD_TO_CRM_CONFIRMATION
            }
            size={"sm"}
            fontWeight={fontWeight.REGULAR}
            color={GREY.SECONDARY}
          />
        </CustomModal>
      )}
    </>
  );
};

export default StatsDialog;
